import Splide from "@splidejs/splide";
import {adjustArrows} from "../../../webpack/modules-optimized/recommenders";
import {clickEvent, documentLoadEvent} from "../../../webpack/modules/events";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";

documentLoadEvent(function() {
    initRecommenders();
});

clickEvent('.no-results-banner a[href^="mailto"]', false, function() {
    ga4TrackSimpleEvent({
        'event': 'noresult_page',
        'method': 'contact'
    });
});

clickEvent('.no-results-recommender[data-type="personalized-services"] a', false, function(element) {
    ga4TrackSimpleEvent({
        'event': 'noresult_page',
        'method': 'custom_product',
        'content_type': element.dataset.nameEvent
    });
});

clickEvent('.no-results-recommender[data-type="personalized-services"] .splide__arrow--next', false, function() {
    ga4TrackSimpleEvent({
        'event': 'noresult_page',
        'method': 'custom_product',
        'content_type': 'see_more'
    });
});

clickEvent('.no-results-recommender[data-type="product-types"] a', false, function(element) {
    ga4TrackSimpleEvent({
        'event': 'noresult_page',
        'method': 'discover_product',
        'content_type': element.dataset.nameEvent
    });
});

clickEvent('.no-results-recommender[data-type="product-types"] .splide__arrow--next', false, function() {
    ga4TrackSimpleEvent({
        'event': 'noresult_page',
        'method': 'discover_product',
        'content_type': 'see_more'
    });
});

function initRecommenders()
{
    let recommenders = document.querySelectorAll('.no-results-recommender');

    recommenders.forEach(function(recommender) {
        let splide = new Splide(recommender, {
            perPage: 5,
            perMove: 5,
            pagination: false,
            rewind: true,
            drag: true,
            gap: '32px',
            breakpoints: {
                1200: {
                    perPage: 4,
                    perMove: 4
                },
                750: {
                    gap: 0,
                    perPage: 1,
                    perMove: 1,
                    focus: 0,
                    omitEnd: true,
                    autoWidth: true,
                }
            }
        }).mount();

        splide.on('mounted resize',function () {
            adjustArrows(recommender);
        });
    });
}